import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">Frederiksted Community Hub</p>
        <h1>Welcome to Frederiksted!</h1>
        <p className="lede">
          Your go-to source for the latest news, resources, and events in Frederiksted. Stay connected with your community and discover what’s happening around you.
        </p>
        <div className="cta-row">
          <a href="/news" target="_self">
            Explore News
          </a>
          <a href="/events" target="_self" className="secondary">
            View Upcoming Events
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Stay Informed</h2>
          <p>
            Get the latest updates on local news and happenings. Our community-focused articles keep you in the loop.
          </p>
        </article>
        <article>
          <h2>Find Resources</h2>
          <p>
            Access valuable resources for residents and visitors alike. From local services to community programs, we’ve got you covered.
          </p>
        </article>
        <article>
          <h2>Join the Fun</h2>
          <p>
            Discover exciting events happening in Frederiksted. Whether you’re a resident or just visiting, there’s always something to enjoy.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;